import { ImportInvoice, ProcessFileDuplicate } from '@/lib/types';
import { api } from '@/lib/utils/api.axios';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { apiBasePaths } from '../_apiPaths';

const QUERY_KEY = ['invoices', 'processfiles'];
const BASE_URL_V1 = `${apiBasePaths.invoices}/v1/processfiles`;
const BASE_URL_V2 = `${apiBasePaths.invoices}/v2/processfiles`;

export const useGetProcessFileDuplicate = (
  id?: string,
): UseQueryResult<ProcessFileDuplicate, Error> =>
  useQuery({
    queryKey: [...QUERY_KEY, id, 'duplicate'],
    queryFn: () =>
      api
        .get<ProcessFileDuplicate>(`${BASE_URL_V2}/${id}/duplicate`)
        .then((r) => r.data),
    enabled: !!id,
  });

export const useGetProcessFileUbl = (
  id: string,
): UseQueryResult<ImportInvoice | undefined, Error> =>
  useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () =>
      id
        ? api.get<ImportInvoice>(`${BASE_URL_V1}/${id}/ubl`).then((r) => r.data)
        : Promise.reject(),
    enabled: !!id,
  });
